/// <amd-module name="Release/Landing/LeftPanel/PipelinesActions" />
import { ReleaseDefinition } from "Release/Client/Contracts/Release";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";

export interface ISearchDefinitionPayload {
    searchText: string;
    searchedDefinitions: ReleaseDefinition[];
}

export interface IRenamePipelinePayload {
    pipelineId: number;
    pipelineName: string;
}

export interface IRenameFolderPayload {
    folderPath?: string;
    oldFolderPath?: string;
}

export interface IMovePipelinePayload {
    pipelineId: number;
    newFolderPath: string;
}

export interface IRemovePipelinePayload {
    pipelineId: number;
    pipelinePath: string;
}

export class PipelinesActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-general-pipelines-actions";
    }

    public initialize(): void {
        this._removePipeline = new Action<IRemovePipelinePayload>();
        this._removeFolder = new Action<string>();
        this._onRenamePipeline = new Action<IRenamePipelinePayload>();
        this._onMovePipeline = new Action<IMovePipelinePayload>();
        this._onRenameFolder = new Action<IRenameFolderPayload>();
        this._clearData = new Action<void>();
    }

    public get removePipeline(): Action<IRemovePipelinePayload> {
        return this._removePipeline;
    }

    public get removeFolder(): Action<string> {
        return this._removeFolder;
    }

    public get onRenamePipeline(): Action<IRenamePipelinePayload> {
        return this._onRenamePipeline;
    }

    public get onMovePipeline(): Action<IMovePipelinePayload> {
        return this._onMovePipeline;
    }

    public get onRenameFolder(): Action<IRenameFolderPayload> {
        return this._onRenameFolder;
    }


    public get clearData(): Action<void> {
        return this._clearData;
    }

    private _removePipeline: Action<IRemovePipelinePayload>;
    private _removeFolder: Action<string>;
    private _onRenamePipeline: Action<IRenamePipelinePayload>;
    private _onMovePipeline: Action<IMovePipelinePayload>;
    private _onRenameFolder: Action<IRenameFolderPayload>;
    private _clearData: Action<void>;
}
